import React, { memo } from 'react'
import { View } from '@instructure/ui-view'
import { Flex } from "@instructure/ui-flex"
import { useState } from 'react'
import { connect } from 'react-redux'
import { IconMoreLine, IconDragHandleLine, IconLockSolid } from '@instructure/ui-icons'
import { SourceContainer } from '../dragAndDrop/SourceContainer.jsx'
import { deleteEnrollment } from '../../actions/courses'
import { Popover } from '@instructure/ui-popover'
import { Button, IconButton } from '@instructure/ui-buttons'
import { Tooltip } from '@instructure/ui-tooltip'
import { Text } from '@instructure/ui-text'
import { List } from '@instructure/ui-list'

const ManageEnrolments = memo(({ token, deleteEnrollment, usersEnrolled, singleEnrollmentIds }) => {
    const [showContent, setShowContent] = useState(false);

    if(usersEnrolled && !usersEnrolled.length) {
        return <View as="div" textAlign="center" borderWidth="small" minWidth="100%"  padding="xx-small" borderRadius="medium" >
            <Text size="x-small" color="primary" >There are currently no users in this section</Text>
        </View>
    }

    return (
        <Flex wrap='wrap' gap='small' >
                {usersEnrolled.map((enrolled) => {
                const {id, user, course_id, user_id, can_be_removed, role_id, role} = enrolled;
                const cantBeRemoved = (singleEnrollmentIds.includes(user_id.toString()) || !can_be_removed);

                // add roles to user enrollments
                user['enrollments'] = [{
                    role_id,
                    role
                }]


                return (
                    <Flex.Item key={enrolled.id} display="block" borderWidth="small"   maxWidth="15rem" padding="xx-small" borderRadius="medium" >
                        <SourceContainer object={user} enrolledId={id} type='fromUsers' preventDrag={cantBeRemoved} >
                            <Flex justifyItems="space-between">
                                <Flex.Item shouldShrink>
                                    <Tooltip renderTip={enrolled.sis_user_id || ""} as="div">
                                        <div tabIndex="0">
                                            <IconDragHandleLine color="secondary" />
                                            <Text weight="bold" size="small" data-testid={`user-name-${id}`}> {user.name} </Text>
                                            <span aria-label={cantBeRemoved ? 'User is locked.' : ''}/>
                                            <span aria-label={user.sis_user_id || ''}/>
                                        </div>
                                    </Tooltip>
                                </Flex.Item>
                                <Flex.Item >
                                <Popover
                                    renderTrigger={!cantBeRemoved && <IconButton screenReaderLabel={`${user.name} - remove from group`} withBackground={false} withBorder={false} ><IconMoreLine/></IconButton>}
                                    isShowingContent={(showContent === id)}
                                    onShowContent={() => {
                                        setShowContent(id)
                                    }}
                                    onHideContent={() => {
                                        setShowContent(false)
                                    }}
                                    on="click"
                                    screenReaderLabel="Popover Dialog to remove user from section"
                                    shouldContainFocus
                                    shouldReturnFocus
                                    shouldCloseOnDocumentClick
                                    offsetY="16px"
                                    mountNode={() => document.getElementById('main')}
                                    >
                                        <List isUnstyled>
                                            <List.Item>
                                                <Button  size="small" margin="x-small" onClick={() => deleteEnrollment(id, course_id, token)}>
                                                    <Text size="x-small" > Remove User </Text>
                                                </Button>
                                            </List.Item>
                                        </List>
                                    </Popover>
                                    {cantBeRemoved && <IconButton screenReaderLabel={`${user.name} - Locked`} withBackground={false} withBorder={false}><IconLockSolid color="secondary" data-testid={`lock-user-${id}`}/></IconButton>}
                                </Flex.Item>
                            </Flex>
                        </SourceContainer>
                    </Flex.Item>
                );
                })}
        </Flex>
    );
})

const mapStateToProps = (state) => {
    const {userAccess: {jwtToken} } = state;
    return {
        token: jwtToken
    }
}

export default connect(mapStateToProps, {deleteEnrollment})(ManageEnrolments);